import React from "react"
import Label from './LabelUtilsComponet'
import Required from './RequiredComponent'

const TextArea = ({ config, onChange }) => {
  return (
    <div className={config.classContainer}>
      <Label {...config} />
      <div className="div-textarea-form">
        <textarea
          className={config.classInput}
          rows={config.rows}
          onChange={(e) => onChange(config.variable, e.target.value, config.type)}
          placeholder={config.placeholder}
          value={config.value}
        />
      </div>
      {
        <Required {...config} msg="Ingrese texto en el campo" />
      }
    </div>
  )
}

export default TextArea;
